import ApplicationController from "./application_controller"
import flatpickr from "flatpickr"

import "flatpickr/dist/flatpickr.min.css"

export default class extends ApplicationController {
  static targets = ["input"]

  connect() {
    this.initializeFlatpickr()
  }

  disconnect() {
    if (this.picker) {
      this.picker.destroy()
    }
  }

  initializeFlatpickr() {
    const enableTime =
      this.data.get("enableTime") === "true"

    const enableDate =
      this.data.get("enableDate") !== "false"

    const mode =
      this.data.get("mode") || "single"

    const minDate =
      this.data.get("minDate") || null

    const maxDate =
      this.data.get("maxDate") || null

    const defaultDate =
      this.data.get("defaultDate") || null

    const altFormat =
      this.data.get("altFormat") ||
      (enableTime
        ? "F j, Y h:i K"
        : "F j, Y")

    const dateFormat =
      this.data.get("dateFormat") ||
      (enableTime
        ? "Y-m-d H:i"
        : "Y-m-d")

    this.picker = flatpickr(this.element, {
      wrap: true,
      allowInput: true,
      disableMobile: true,

      monthSelectorType: "dropdown",

      enableTime: enableTime,
      noCalendar: !enableDate,
      time_24hr: false,

      altInput: true,
      altFormat: altFormat,
      dateFormat: dateFormat,

      mode: mode,
      defaultDate: defaultDate,
      minDate: minDate,
      maxDate: maxDate,

      prevArrow:
        '<i class="fa-solid fa-chevron-left"></i>',

      nextArrow:
        '<i class="fa-solid fa-chevron-right"></i>',

      onReady: (_, __, instance) => {
        instance.calendarContainer.classList.add(
          "gv-flatpickr-theme"
        )
      }
    })
  }

  clear() {
    this.picker?.clear()
  }

  open() {
    this.picker?.open()
  }

  close() {
    this.picker?.close()
  }
}